export const termsOfUse =
  "https://static.ameelio.org/connect-terms-of-use.html";
export const privacyPolicy = "https://static.ameelio.org/privacy-policy.html";
